// @flow
import React, { type Element } from 'react';
import { get, reduce } from 'lodash';
import { Row, Col, Button, RatingDisplay } from 'angieslist-react-components';
import { RatingDistribution, RatingDetails } from 'angieslist-composed-components';
import { Track } from 'angieslist-app-platform';
import type { MetricCategory } from '../../../types';
import './reviewRatingDetails.scss';

type Props = {
  category?: MetricCategory,
  ratingsMetrics: Object,
  ratingDetails: Object,
  displayReviewCount: number,
  displayStarRating?: number
};

type State = {
  collapsed: boolean,
};

class ReviewRatingDetailsComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { collapsed: false };
  }
  state: State;
  props: Props;

  isCollapsed: (() => boolean) = () => this.state.collapsed;

  toggleSummaryGraph: ((event: any) => void) = (event: any) => {
    setTimeout(
      () => {
        this.setState({ collapsed: !this.state.collapsed });
      },
      100,
    );
    event.preventDefault();
  }


  render(): Element<"section"> {
    const {
      category, ratingsMetrics, ratingDetails,
      displayReviewCount, displayStarRating,
    } = this.props;
    const collapsed = this.isCollapsed();
    const categoryId: number = get(category, 'id', 0);
    const categoryName: string = get(category, 'name', '');
    const reviewCount: number = get(category, 'displayReviewCount', 0);

    const ratingsObj = reduce(ratingsMetrics, (object, value, key) => ({
      ...object,
      [get(value, 'starRating')]: get(value, 'count'),
    }), {});


    const ratingDetailsArr =
    ratingDetails.map(rating => ({
      ratingName: rating.ratingType,
      ratingValue: rating.starRating,
    }
    ));


    return (
      <section className={!collapsed ? 'reviews-head_summary' : ''}>
        <h2 className="reviews-head_headline">
          <span className="reviews-head_count">
            {`${reviewCount} Reviews in: `}
          </span>
          <span className="reviews-head_category">{categoryName}</span>
          <Track>
            <Button
              bsSize="small"
              id={collapsed ? 'review-head_summary-graph-open' : 'review-head_summary-graph-close'}
              bsStyle="link"
              className="summary-graph-btn"
              style={{ fontSize: '.45em', fontWeight: 700 }}
              onClick={e => this.toggleSummaryGraph(e)}
              data-track-btn-state={collapsed ? 'Open' : 'Close'}
              data-track-category-id={categoryId}
              data-track-category-name={categoryName}
            >
              <i style={{ paddingRight: 5 }} className="icon icon-graph" />
              Summary Graph
              <i
                className={`icon icon-${collapsed ? 'down' : 'up'}-open`}
                style={{ paddingLeft: 5 }}
              />
            </Button>
          </Track>
        </h2>

        <If condition={!collapsed}>
          <Row>
            <Col xs={12} lg={6} style={{ marginTop: 25 }}>
              <RatingDisplay
                rating={displayStarRating}
                reviewCount={displayReviewCount}
                reviewCountLocation="bottom"
              />

              <RatingDistribution
                title="Ratings Distribution"
                ratingsDistribution={ratingsObj}
                customId="review-ratings-distribution"
              />
            </Col>
            <Col xs={12} lg={6} style={{ paddingBottom: 10, marginTop: 65 }}>
              <RatingDetails
                ratingDetails={ratingDetailsArr}
                title="Ratings Details"
                customId="review-ratings-details"
              />
            </Col>
          </Row>
          <Track>
            <Button
              id="review-head_summary-graph-close-btn"
              bsStyle="link"
              className="text-danger pull-right"
              bsSize="small"
              onClick={e => this.toggleSummaryGraph(e)}
              data-track-btn-state={collapsed ? 'Open' : 'Close'}
              data-track-category-id={categoryId}
              data-track-category-name={categoryName}
            >
              Close <i className="icon icon-up-open" />
            </Button>
          </Track>
        </If>
      </section>
    );
  }
}

export default ReviewRatingDetailsComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewRatingDetails.js